import * as Cookie from "js-cookie";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { DecodeToken } from "views/LandingPageView/NewLandingPage";
import React from "react";
import { useHistory } from "react-router";
import { LANDING_PAGE_ROUTE } from "config/route-consts";

// import { notification } from "helpers/notification";
function Login() {
  const history = useHistory();
  React.useEffect(() => {
    if (
      Cookie.get("access_token") &&
      jwtDecode<DecodeToken>(Cookie.get("access_token")).exp >
        moment.now() / 1000
    ) {
      history.push(`${LANDING_PAGE_ROUTE}`);
    } else {
      window.location.href = `${process.env.REACT_APP_KEYCLOAK_URL}/auth?response_type=code&client_id=emp-con-app&redirect_uri=${window.location.protocol}//${window.location.host}${process.env.REACT_APP_PREFIX_URL}/login-sso-waiting-page`;
    }
  });

  return <></>;
}

export default Login;
